import {Observable} from 'rxjs';

export interface DataSourceResponse<T> {
    list: T[];
    count: number;
}

export abstract class DataSourceService<T> {
    public abstract loadData(
        filter: string,
        orderBy: string,
        orderDirection: string,
        pageNumber: number,
        pageSize: number,
        globalFilter: string
    ): Observable<DataSourceResponse<T>>;
}
